import Mustache from "mustache";
import type { RJSFSchema } from "@rjsf/utils";
import type {
  JsonValue,
  WorkSettingsData,
  WorkSettingsVariant,
} from "../../../../shared/work-settings";

function display(value: JsonValue, schema?: RJSFSchema): unknown {
  const option = schema?.oneOf?.find(
    (item) => typeof item === "object" && item.const === value,
  );
  // An option's description explains it in the form's info bubble; the model
  // gets the same explanation after the label.
  if (option && typeof option === "object" && option.title)
    return option.description ? `${option.title} — ${option.description}` : option.title;
  if (Array.isArray(value))
    return value.map((item) =>
      display(
        item,
        typeof schema?.items === "object" && !Array.isArray(schema.items)
          ? schema.items
          : undefined,
      ),
    );
  if (value && typeof value === "object")
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        display(
          item,
          typeof schema?.properties?.[key] === "object"
            ? schema.properties[key]
            : undefined,
        ),
      ]),
    );
  return value;
}
export function renderWorkPrompt(
  variant: WorkSettingsVariant,
  data: WorkSettingsData,
): string {
  return Mustache.render(
    variant.prompt,
    display(data, variant.schema),
    {},
    { escape: (value) => value },
  ).trim();
}
